import WheelTitleIcon from 'ui/SVG/WheelTitleIcon';
import './Title.scss';

interface TitleProps {
  title?: string;
}

const Title: React.FC<TitleProps> = ({ title }) => {
  return title ? (
    <div className="content-frame-title">
      <div className="content-frame-title__wheel">
        <WheelTitleIcon />
        <img src={require('images/logo.png')} alt="logo" />
      </div>
      <h3 className="content-frame-title__title">{title}</h3>
    </div>
  ) : null;
};

export default Title;
